// import queryString from "query-string";
import React, { useContext } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import api from "../../../../api";
import values from "../../../../values";
import Context from "../../../../context";
import { IItem } from "../../../../types/common.interface";
import utils from "../../../../utils";
import { ICreateAndUpdateCompany } from "../../../../types/company.interface";
import { ORDER_STATUS } from "../../../../values/dropdownItems";

const FilterAgent = () => {
  // ============================== Value Validation ================================

  //   const {search} = queryString.parse(window.location.search);
  const [effect, setEffect] = React.useState(false);
  const [selectedFilters, setSelectedFilters] = React.useState<any>({
    // isBlock,
    // isApproved,
    // province,
    // city,
  });
  const [clientSearchValue, setClientSearchValue] = React.useState<any>();
  const [selectedClient, setSelectedClient] = React.useState<any>();

  const { requestOrder, setRequestOrder } = useContext(Context.OrderScreen);
  const userType = utils.stringHexConversion?.reverse(
    Cookies.get(constants?.USER?.TYPE)
  );

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const allCompany = useQuery([values.useQueryKeys.getAllCompany], () =>
    api.postMethod.administrator.getAllCompany({})
  );
  // const allDriver = useQuery([values.useQueryKeys.getAllDriver], () =>
  //   api.postMethod.common.findDriver({ page: 1, limit: 30 })
  // );

  const allClient = useQuery(
    [values.useQueryKeys.getAllClient, clientSearchValue],
    () =>
      api.getMethod.common.findClient({
        search: {
          base: clientSearchValue.base.value,
          value: clientSearchValue?.searchedValue,
        },
      })
  );

  // const allWorkTimes = useQuery([values.useQueryKeys.getAllWorkTime], () =>
  //   api.getMethod.company.findWorkTime({})
  // );
  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================
  // const driversWithCompleteName = allDriver?.data?.result?.docs?.map(
  //   (item: any) => {
  //     return { ...item, completeName: item?.firstName + " " + item?.lastName };
  //   }
  // );
  const clientsWithCompleteName = allClient?.data?.result?.docs?.map(
    (item: any) => {
      return {
        ...item,
        completeName:
          item?.firstName +
          " " +
          item?.lastName +
          " ( " +
          item?.phoneNumber +
          " ) ",
      };
    }
  );
  // const workTimeWithCompleteName = utils?.workTimeWithCompeleteTitle(
  //   allWorkTimes?.data?.result
  // );

  // ================================== JSX Content ================================

  return (
    <div className="filter-container">
      <CustomDropdownFilter title="مرتب سازی براساس">
        {userType !== "COMPANY" && (
          <>
            <p className="filter-labels">شرکت:</p>
            <CustomDropdownSearch
              items={allCompany?.data?.result}
              itemName="name"
              defaultItem={requestOrder?.filters?.company}
              onSelectItem={(event: ICreateAndUpdateCompany) =>
                setRequestOrder!({
                  ...requestOrder,
                  filters: {
                    ...requestOrder?.filters,
                    company: event,
                  },
                })
              }
              placeHolder="انتخاب شرکت"
              isLoading={allCompany.isLoading}
            />
            <p className="filter-labels">مشتری:</p>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.CLIENT_BASE_SEARCH}
              items={clientsWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: any) => {
                setSelectedClient(event);
                setRequestOrder!({
                  ...requestOrder,
                  filters: {
                    ...requestOrder?.filters,
                    client: event,
                  },
                });

                // setDropDownErrors({ ...dropDownErrors, parent: "" });
              }}
              defaultItem={selectedClient}
              searchedValue={clientSearchValue}
              setSearchedValue={setClientSearchValue}
              placeHolder="انتخاب مشتری"
              isLoading={allClient.isLoading}
              selectedBaseSearch={clientSearchValue?.base?.value}
            />{" "}
          </>
        )}
        {/* <>
          <p className="filter-labels">ساعت کاری:</p>
          <CustomDropdownSearch
            items={workTimeWithCompleteName}
            itemName="completeName"
            defaultItem={requestOrder?.filters?.workTimes}
            onSelectItem={(event: ICreateAndUpdateWorkTime) =>
              setRequestOrder!({
                ...requestOrder,
                filters: {
                  ...requestOrder?.filters,
                  workTimes: event,
                },
              })
            }
            placeHolder="انتخاب ساعت کاری"
            isLoading={allWorkTimes.isLoading}
          />
        </> */}
        <>
          <p className="filter-labels">وضعیت:</p>
          <CustomDropdownSearch
            items={ORDER_STATUS}
            itemName="name"
            defaultItem={requestOrder?.filters?.status}
            onSelectItem={(event: IItem) =>
              setRequestOrder!({
                ...requestOrder,
                filters: {
                  ...requestOrder?.filters,
                  status: event,
                },
              })
            }
            placeHolder="انتخاب وضعیت"
          />
        </>
        <div className="filter-footer">
          <CustomButton2
            title="تنظیم مجدد"
            onClick={() => {
              setRequestOrder!({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

const gender: IItem[] = [
  { name: "مرد", value: "MALE" },
  { name: "زن", value: "FEMALE" },
];
const marital: IItem[] = [
  { name: "مجرد", value: "SINGLE" },
  { name: "متاهل", value: "MARRIED" },
];

export default FilterAgent;
